import Copy from '../../../assets/copy.svg';

const CopyIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Copy {...props} />;
};

export default CopyIcon;
